import { Menu as MenuAntd } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function pathMatchesMenuKey(pathname, menuKey) {
  if (pathname === menuKey) {
    return true;
  }
  return pathname.startsWith(`${menuKey}/`);
}

const Menu = ({ topics }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [openKeys, setOpenKeys] = useState([]);

  const selectedKeys = useMemo(() => {
    if (!topics?.length) {
      return [];
    }
    const first = topics[0];
    if (first?.children?.length) {
      for (const topic of topics) {
        const match = [...(topic.children || [])]
          .sort((a, b) => String(b.key).length - String(a.key).length)
          .find((c) => pathMatchesMenuKey(pathname, c.key));
        if (match) {
          return [match.key];
        }
      }
      return [];
    }
    const flatMatch = [...topics]
      .sort((a, b) => String(b.key).length - String(a.key).length)
      .find((item) => pathMatchesMenuKey(pathname, item.key));
    return flatMatch ? [flatMatch.key] : [];
  }, [topics, pathname]);

  useEffect(() => {
    if (!topics?.length) {
      return;
    }
    const first = topics[0];
    if (!first?.children?.length) {
      return;
    }
    const parentKeys = topics
      .filter((topic) =>
        (topic.children || []).some((c) => pathMatchesMenuKey(pathname, c.key)),
      )
      .map((topic) => topic.key);
    setOpenKeys((prev) => [...new Set([...prev, ...parentKeys])]);
  }, [pathname, topics]);

  return (
    <MenuAntd
      mode="inline"
      selectedKeys={selectedKeys}
      openKeys={openKeys}
      onOpenChange={setOpenKeys}
      className="items"
      onClick={({ key }) => navigate(key)}
      items={topics}
    />
  );
};

export default Menu;
